import { TeamResponseDto } from 'modules/teams/domain/interfaces/response-dto';
import { Team } from 'modules/teams/domain/interfaces/team';
import { TEAM_DEFAULT_LOGO } from 'shared/constants/links';
import { mapPlayerDtoToPlayer } from 'modules/tournaments/domain/data-mappers/championship-game-teams-mapper';
import { getNormalizedDate } from 'shared/utils/get-normalized-date';

export function mapTeamResponseDto(teams: TeamResponseDto[]): Team[] {
  return teams.map((team) => ({
    id: team.id,
    name: team.name,
    logo: team.emblem && {
      id: team.emblem?.id,
      url: team.emblem?.externalUrl ?? TEAM_DEFAULT_LOGO,
    },
    createdAt: team.createdAt && getNormalizedDate(team.createdAt),
    players: team.members?.map(mapPlayerDtoToPlayer) ?? [],
    entryRequests:
      team.entryRequest?.map((player) => ({
        ...mapPlayerDtoToPlayer(player),
        status: player.status,
      })) ?? [],
  }));
}
